import { Injectable } from '@angular/core';

/**
 * Logger service for managing console logs based on environment.
 * In production builds, console logs are disabled to keep the console clean
 * and avoid exposing sensitive information.
 */
@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  // Check if we're in production by looking for typical production indicators
  private isProduction = this.detectProductionEnvironment();

  private detectProductionEnvironment(): boolean {
    // Check if we're not in localhost
    const hostname = window.location.hostname;
    return hostname !== 'localhost' && hostname !== '127.0.0.1';
  }

  /**
   * Log a message to console in development mode only
   */
  log(message?: any, ...optionalParams: any[]): void {
    if (!this.isProduction) {
      console.log(message, ...optionalParams);
    }
  }

  /**
   * Log an error to console in development mode only
   */
  error(message?: any, ...optionalParams: any[]): void {
    if (!this.isProduction) {
      console.error(message, ...optionalParams);
    }
  }

  /**
   * Log a warning to console in development mode only
   */
  warn(message?: any, ...optionalParams: any[]): void {
    if (!this.isProduction) {
      console.warn(message, ...optionalParams);
    }
  }

  /**
   * Log debug info to console in development mode only
   */
  debug(message?: any, ...optionalParams: any[]): void {
    if (!this.isProduction) {
      console.debug(message, ...optionalParams);
    }
  }

  /**
   * Always log critical errors regardless of environment
   */
  logCriticalError(message: string, error?: any): void {
    console.error('CRITICAL ERROR:', message, error);
    // In a real application, you might send this to a logging service
  }
}
